import request from '@/utils/workFlowRequest'
import constants from '@/utils/constants'
const PracticeTestPaperService = {
  state: {},

  mutations: {},

  actions: {
    /**
     * 练习试卷分页
     */
    practiceTestPaperPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'practiceTestPaper/page', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 根据主键获得练习试卷
    */
    practiceTestPaperGetById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'practiceTestPaper/getById/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 根据主键获得练习试卷详情
    */
    practiceTestPaperGetDetailsById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'practiceTestPaper/getDetailsById/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 练习试卷保存
     */
    practiceTestPaperSave({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'practiceTestPaper/save', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 练习试卷更新
     */
    practiceTestPaperUpdate({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'practiceTestPaper/update/' + params.id, params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 练习试卷删除
     */
    practiceTestPaperRemove({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'practiceTestPaper/remove', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 开始练习
     */
    startPracticeExam({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'practiceTestPaper/startPracticeExam', { id: id }).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default PracticeTestPaperService
